/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Category,
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface CategoryDataFrame
 */
export interface CategoryDataFrame {
    /**
     * 
     * @type {number}
     * @memberof CategoryDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Category>}
     * @memberof CategoryDataFrame
     */
    data: Array<Category>;
}

export function CategoryDataFrameFromJSON(json: any): CategoryDataFrame {
    return CategoryDataFrameFromJSONTyped(json, false);
}

export function CategoryDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(CategoryFromJSON)),
    };
}

export function CategoryDataFrameToJSON(value?: CategoryDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(CategoryToJSON)),
    };
}


